import React       from 'react';
import PropTypes   from 'prop-types'
import HiddenInput from 'pu-react/components/base/HiddenInput';

// render all parameters selected(customer or bestPrice) on hidden fields
const Hidden = (props) => {
  const {
    variantId, itemSelected, itemId, parameters,
  } = props
  const groupName = `items[${itemId}][parameters]`
  return (
    <div>
      {Object.keys(parameters).map((name) => (
        <input
          type="hidden"
          name={`${groupName}[${name}]`}
          key={name}
          value={props.parameters[name]} />
      ))}
      <HiddenInput
        name="item_selected"
        groupName={groupName}
        value={itemSelected} />
      <HiddenInput
        name="variant_id"
        groupName={`items[${itemId}]`}
        value={variantId} />
    </div>
  );
};

Hidden.propTypes = {
  variantId: PropTypes.number.isRequired,
  itemId: PropTypes.number.isRequired,
  parameters: PropTypes.object.isRequired,
  itemSelected: PropTypes.bool.isRequired,
}

export default Hidden
